// extracted by css-extract-rspack-plugin
export default {"form":"qjZwZQ3ZshU6IuPG","delete":"FQggSE9H4LI4jfie","date_picker_width":"VgVcdFhLz4W4XXpx","labelDiv":"MxoLQo6rSQZie6ig","btn":"NHdHEx7bo0ArKA7i","btns":"GGqZb2pYl5c930h0"};